import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
@Component({
  selector: 'sm-alert-for-mobile-log',
  templateUrl: './alert-for-mobile-log.component.html',
  styleUrls: ['./alert-for-mobile-log.component.scss']
})
export class AlertForMobileLogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public parentdata: any,  private clipboard: Clipboard){
  
  }

  msg:any
  ngOnInit(): void {
    this.msg = this.parentdata.data
  }

  copyToClipboard() {
    this.clipboard.copy(this.msg);
  }

}
